import { RegistrationType, NgoCategory } from '../types';

export const NGO_PROFILE_REGISTRATION_TYPES: {
	text: string;
	value: string;
}[] = [
	{
		text: 'pages.ngo.profiles.registrationTypes.taxExempt',
		value: RegistrationType.taxExempt,
	},
	{
		text: 'pages.ngo.profiles.registrationTypes.societies',
		value: RegistrationType.societies,
	},
	{
		text: 'pages.ngo.profiles.registrationTypes.limitByGuarantee',
		value: RegistrationType.limitByGuarantee,
	},
	{
		text: 'pages.ngo.profiles.registrationTypes.limitByShares',
		value: RegistrationType.limitByShares,
	},
];

export const NGO_PROFILE_ORGANISATION_TYPES: {
	text: string;
	value: string;
}[] = [
	{
		text: 'pages.ngo.profiles.organisationTypes.ngo',
		value: NgoCategory.ngo,
	},
	{
		text: 'pages.ngo.profiles.organisationTypes.se',
		value: NgoCategory.se,
	},
	{
		text: 'pages.ngo.profiles.organisationTypes.school',
		value: NgoCategory.school,
	},
	{
		text: 'pages.ngo.profiles.organisationTypes.university',
		value: NgoCategory.university,
	},
	{
		text: 'pages.ngo.profiles.organisationTypes.corporate',
		value: NgoCategory.corporate,
	},
];

export const SC_ADMIN_ACCOUNT_ROLE_CODE = 'scAdminAccount';
export const MAIN_ACCOUNT_ROLE_CODE = 'mainAccount';
export const SERVICE_ACCOUNT_ROLE_CODE = 'serviceAccount';
export const MTR_NGO_ID = 990003;
